import { Cache } from "memory-cache";
import { StaticStorageClient } from "../service/staticstorageclient";
import { BlueprintEntity } from ".";

const azureStorageClient = new StaticStorageClient();

// Cache
const cache = new Cache();

export async function getCachedBlueprintEntity(blueprint_id: number): Promise<BlueprintEntity | null> {
  let entity: any = await cache.get(blueprint_id.toString());
  if (entity) {
    return entity;
  }
  try {
    if (blueprint_id === 16672) blueprint_id = 46207;
    const blueprint = await azureStorageClient.get_blueprints_blueprint_id(blueprint_id);
    if (blueprint !== null) {
      entity = new BlueprintEntity(blueprint_id, blueprint);
      cache.put(blueprint_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } else {
      return null;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getCachedBlueprintEntityByTypeId(type_id: number): Promise<BlueprintEntity | null> {
  const blueprint = await azureStorageClient.get_blueprints_type_id(type_id);
  if (blueprint !== null) {
    let entity: any = await cache.get(blueprint["blueprintTypeID"].toString());
    if (entity) {
      return entity;
    }
    try {
      entity = new BlueprintEntity(blueprint.blueprintTypeID, blueprint);
      cache.put(blueprint.blueprintTypeID.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } catch (error) {
      console.error(error);
      return null;
    }
  } else {
    return null;
  }
}
